<svelte:head>
    <script
        src="https://www.google.com/recaptcha/api.js?onload=grecaptchaLoaded&render=6LdI1rAUAAAAACI0GsFv-yRpC0tPF5ECiIMDUz2x"
        async
    ></script>
    <script
        src="https://assets.propublica.org/static/prod/v5/js/deploy/utils.js"
        async
    ></script>
    <script
        src="https://assets.propublica.org/static/prod/v5/js/deploy/user-funnel.js"
        async
    ></script>
    <script
        src="https://assets.propublica.org/static/prod/v5/js/deploy/recaptcha-init.js"
        async
    ></script>
</svelte:head>
